import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function LegalLayout({ eyebrow, title, updated, children }) {
  return (
    <main className="pt-32 md:pt-40 pb-28" data-testid="legal-page">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <motion.p initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="font-sans text-xs uppercase tracking-mega text-brass mb-6">
          {eyebrow}
        </motion.p>
        <motion.h1 initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.1 }} className="font-serif text-5xl md:text-6xl leading-[1.02] text-ink">
          {title}
        </motion.h1>
        {updated && <p className="mt-4 font-sans text-xs text-ink-muted">Last updated: {updated}</p>}
        <div className="mt-12 space-y-10">{children}</div>
        <div className="mt-16 pt-8 border-t border-line">
          <Link to="/" className="font-sans text-sm text-brass hover:underline" data-testid="legal-home-link">Return to Get Virtual Growth →</Link>
        </div>
      </div>
    </main>
  );
}

export function Section({ heading, children }) {
  return (
    <section>
      <h2 className="font-serif text-2xl md:text-3xl text-ink mb-3">{heading}</h2>
      <div className="space-y-3 font-sans text-ink-muted leading-relaxed">{children}</div>
    </section>
  );
}
